import { render, staticRenderFns } from "./TedsLauncherTopBar.vue?vue&type=template&id=1b85ebc2&"
import script from "./TedsLauncherTopBar.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherTopBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports